import { gql } from '@apollo/client';

export const CREATE_OPTION_QUERY = gql`
  mutation CreateOptionQuery($params: CreateOptionQueryInput!) {
    createOptionQuery(params: $params) {
      success
      message
      errors
      data {
        id
        queryKey
        description
        sql
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_OPTION_QUERY = gql`
  mutation UpdateOptionQuery($params: UpdateOptionQueryInput!) {
    updateOptionQuery(params: $params) {
      success
      message
      errors
      data {
        id
        queryKey
        description
        sql
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_OPTION_QUERY = gql`
  mutation DeleteOptionQuery($params: DeleteOptionQueryInput!) {
    deleteOptionQuery(params: $params) {
      success
      message
      errors
    }
  }
`;
